module.exports = __webpack_public_path__ + "img/pantalla-6-6.59a1d801.png";